import { useAutoRoutingDE } from '../../../hooks/useAutoRouting/useAutoRoutingDE';
import { useBrokerRedirect } from '../../../hooks/useBrokerRedirect';

type TProps = {
  children?: React.ReactNode;
};

const StepRouterDE = ({ children }: TProps) => {
  useBrokerRedirect();
  useAutoRoutingDE();

  return <>{children}</>;
};

export default StepRouterDE;
